var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 956448842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M8.58036 6.20616V12H7.41128V6.20616H8.58036ZM7.33398 4.68541C7.33398 4.48907 7.39196 4.32664 7.5079 4.19813C7.62706 4.06604 7.79131 4 8.00065 4C8.20677 4 8.36941 4.06604 8.48857 4.19813C8.60774 4.32664 8.66732 4.48907 8.66732 4.68541C8.66732 4.87818 8.60774 5.03882 8.48857 5.16734C8.36941 5.29585 8.20677 5.36011 8.00065 5.36011C7.79131 5.36011 7.62706 5.29585 7.5079 5.16734C7.39196 5.03882 7.33398 4.87818 7.33398 4.68541Z",
    fill: "#6E757C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 8,
    cy: 8,
    r: 7.62121,
    stroke: "#D9D9D9",
    strokeWidth: 0.757576
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/infoWhite.304b49fdc7d65ed22732223283387c39.svg";
export { ForwardRef as ReactComponent };